import { useState } from 'react';
import { fetchWithAuth } from '../lib/fetchWithAuth';

// Shared profile field state + fetch/update calls used by GardenPage and AddTreePage.
// Home-location parsing and the update payload differ slightly per page (see each
// page's `onProfileLoaded`/`updateProfile` call), so those stay page-specific.
export function useUserProfile(onUnauthorized: () => void) {
    const [isProfileOpen, setIsProfileOpen] = useState(false);
    const [isEditingProfile, setIsEditingProfile] = useState(false);
    const [profileName, setProfileName] = useState('');
    const [profileAddress, setProfileAddress] = useState('');
    const [profileCity, setProfileCity] = useState('');
    const [profileState, setProfileState] = useState('');
    const [profileZipCode, setProfileZipCode] = useState('');
    const [saveLoading, setSaveLoading] = useState(false);

    const fetchUserProfile = async (): Promise<any | null> => {
        try {
            const res = await fetchWithAuth('/api/users/profile');
            if (!res.ok) {
                onUnauthorized();
                return null;
            }
            const data = await res.json();
            setProfileName(data.name || '');
            setProfileAddress(data.address || '');
            setProfileCity(data.city || '');
            setProfileState(data.state || '');
            setProfileZipCode(data.zipCode || '');
            return data;
        } catch (err) {
            console.error("Error pulling database profiles:", err);
            return null;
        }
    };

    const updateProfile = async (payload: Record<string, any>): Promise<boolean> => {
        setSaveLoading(true);
        try {
            const response = await fetchWithAuth('/api/users/profile', {
                method: 'PUT',
                body: JSON.stringify(payload)
            });
            if (response.ok) {
                setIsEditingProfile(false);
                await fetchUserProfile();
                return true;
            }
            return false;
        } finally {
            setSaveLoading(false);
        }
    };

    return {
        isProfileOpen, setIsProfileOpen, isEditingProfile, setIsEditingProfile,
        profileName, setProfileName, profileAddress, profileCity, profileState, profileZipCode,
        saveLoading, fetchUserProfile, updateProfile,
    };
}
